import { deliveryInstructionApis } from '@apis/deliveryInstructionApis';
import { bookingInquiryApis, dashboardBookingInquiryApis } from '@apis/next/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { AdminPatchDeliveryInstruction } from '@models/DeliveryInstruction';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchDeliveryInstruction = (d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: AdminPatchDeliveryInstruction) => {
      const response = await deliveryInstructionApis.patch(
        '/dashboard/delivery-instruction/{d2d_no}/',
        {
          path: { d2d_no },
          body,
        },
      );

      if (response[400]) {
        throw new FormError('PatchDeliveryInstructionError', response[400]);
      }

      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/dashbaord/delivery-instruction/', d2d_no]);
        queryClient.invalidateQueries(['/delivery-instruction/', d2d_no]);
        queryClient.invalidateQueries(
          dashboardBookingInquiryApis.getKeyByPath(
            'get',
            '/dashboard/booking-inquiry/:d2d_no/status-flows',
          ),
        );
        queryClient.invalidateQueries(
          bookingInquiryApis.getKeyByPath('get', '/booking-inquiry/:d2d_no/status-flows'),
        );
      },
    },
  );
};
